import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Grid } from "semantic-ui-react";
import CommonPageHeader from "../../common/ui/page-header/CommonPageHeader";
import "../documents/Documents.css";
import "../timesheets/TimeSheets.css";
import "./Payroll.css";

const RunPayrollPage = () => {
  const { t } = useTranslation();
  const [preview, setPreview] = useState(null);

  const runGenerate = () => {
    setPreview({
      gross: "125,400",
      earnings: "118,200",
      incomeTax: "8,400",
      loan: "1,200",
      addition: "500",
      deduction: "3,100",
      net: "106,400",
    });
  };

  return (
    <div className="documents-page payroll-page ts-page px-3 px-md-4 py-4">
      <CommonPageHeader
        icon={<i className="bi bi-play-circle" />}
        title={t("app.payroll.run.title")}
        description={t("app.payroll.run.subtitle")}
      />

      <Grid stackable>
        <Grid.Row>
          <Grid.Column width={16} computer={10}>
            <div className="payroll-overview-panel mb-3">
              <h3 className="h6 fw-bold mb-3">{t("app.payroll.run.generateTitle")}</h3>
              <Form>
                <Form.Field>
                  <label>{t("app.payroll.run.fieldPeriod")}</label>
                  <input type="month" className="form-control" />
                </Form.Field>
                <Form.Field>
                  <label>{t("app.payroll.run.fieldOffice")}</label>
                  <select className="form-select">
                    <option>{t("app.payroll.common.allOffices")}</option>
                    <option>HQ — Dubai</option>
                  </select>
                </Form.Field>
              </Form>
              <div className="d-flex flex-wrap gap-2 mt-3">
                <Button primary type="button" onClick={runGenerate}>
                  {t("app.payroll.run.generate")}
                </Button>
                <Button type="button" basic>
                  {t("app.payroll.run.sendApproval")}
                </Button>
              </div>
            </div>
          </Grid.Column>
          <Grid.Column width={16} computer={6}>
            <div className="payroll-overview-panel">
              <h3 className="h6 fw-bold mb-3">{t("app.payroll.run.summaryTitle")}</h3>
              {!preview ? (
                <p className="text-muted small mb-0">{t("app.payroll.run.summaryPlaceholder")}</p>
              ) : (
                <ul className="list-unstyled mb-0 small">
                  <li className="d-flex justify-content-between py-1 border-bottom border-light">
                    <span>{t("app.payroll.run.lblGross")}</span>
                    <span className="fw-semibold">{preview.gross}</span>
                  </li>
                  <li className="d-flex justify-content-between py-1 border-bottom border-light">
                    <span>{t("app.payroll.run.lblEarnings")}</span>
                    <span>{preview.earnings}</span>
                  </li>
                  <li className="d-flex justify-content-between py-1 border-bottom border-light">
                    <span>{t("app.payroll.run.lblTax")}</span>
                    <span>{preview.incomeTax}</span>
                  </li>
                  <li className="d-flex justify-content-between py-1 border-bottom border-light">
                    <span>{t("app.payroll.run.lblLoan")}</span>
                    <span>{preview.loan}</span>
                  </li>
                  <li className="d-flex justify-content-between py-1 border-bottom border-light">
                    <span>{t("app.payroll.run.lblAddition")}</span>
                    <span>{preview.addition}</span>
                  </li>
                  <li className="d-flex justify-content-between py-1 border-bottom border-light">
                    <span>{t("app.payroll.run.lblDeduction")}</span>
                    <span>{preview.deduction}</span>
                  </li>
                  <li className="d-flex justify-content-between py-2 fw-bold">
                    <span>{t("app.payroll.run.lblNet")}</span>
                    <span>{preview.net}</span>
                  </li>
                </ul>
              )}
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default RunPayrollPage;
